
import React from 'react'

export default function PolygonGreenLine() { return (<svg width="77" height="76" viewBox="0 0 77 76" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M75.6465 0.615234L75.6465 74.4982L1.61576 0.615231L75.6465 0.615234Z" stroke="#07BDBD"/>
</svg>)}
